import { Outlet, RouteObject } from '@rocketlane/rocket-router';
import { KnowledgeBaseFolderPage } from 'components/pages/knowledge-base/folder/page';
import { KnowledgeBasePage } from 'components/pages/knowledge-base/page';
import { ROUTE_PATHS } from './route-paths';

export const knowledgeBaseRoutes: RouteObject = {
  path: ROUTE_PATHS.KNOWLEDGE_BASE,
  element: <Outlet />,
  children: [
    {
      index: true,
      element: <KnowledgeBasePage />,
    },
    {
      path: ROUTE_PATHS.KNOWLEDGE_BASE_FOLDER,
      element: <KnowledgeBaseFolderPage />,
    },
  ],
};
